import styled from 'styled-components';

// UTILITY
// import { breakpoints } from '@/utility/breakpoints';
export const Container = styled.div`
  .faq {
    padding-top: 60px;
    padding-bottom: 62px;
  }
`;

export default Container;
